import React from "react";
import Keyboard from "react-simple-keyboard";
import "react-simple-keyboard/build/css/index.css";

interface VirtualKeyboardProps {
  onChange: (value: string) => void;
  onClose: () => void;
  currentValue: string;
}

const VirtualKeyboard: React.FC<VirtualKeyboardProps> = ({ onChange, onClose, currentValue }) => {
  function handleKeyPress(button: string) {
    if (button === "{bksp}") {
      onChange(currentValue.slice(0, -1)); // Apaga o último caractere
    } else {
      onChange(currentValue + button);
    }
  }

  return (
    <div
      style={{
        width: "100%",
        background: "#fff",
        textAlign: "center",
        borderRadius: "10px",
        boxShadow: "0px 4px 6px rgba(0,0,0,0.1)",
        padding: "10px",
        marginTop: "10px", // Espaço acima para separar do input
      }}
    >
      <Keyboard
        layout={{
          default: ["1 2 3", "4 5 6", "7 8 9", "0 {bksp}"],
        }}
        display={{
          "{bksp}": "⌫",
        }}
        onKeyPress={handleKeyPress}
      />
      <button
        type="button"
        onClick={onClose}
        style={{
          width: "100%",
          padding: "10px",
          background: "red",
          color: "white",
          border: "none",
          fontSize: "16px",
          cursor: "pointer",
        }}
      >
        Fechar Teclado
      </button>
    </div>
  );
};

export default VirtualKeyboard;
